<template>
  <div>
    <g-invoice/>
  </div>
</template>
<script>
import GInvoice from "../components/GInvoice";
export default {
  components: {GInvoice}
}
</script>